export var Progress = {
  baseStyle: {
    track: {
      bg: '#F0F0F0'
    }
  },
  sizes: {
    xs: {
      track: {
        borderRadius: '2px'
      }
    },
    sm: {
      track: {
        borderRadius: '2px'
      }
    },
    md: {
      track: {
        borderRadius: '2px'
      }
    },
    lg: {
      track: {
        borderRadius: 'sm'
      }
    }
  }
};